import { httpClient, handleError } from "./httpService.js";
import { DATA_URL, FIELDS } from "./constants.js";

/**
 * Get contributor data from JSON file
 */
const getData = async function() {
    try {
        var response = await httpClient.get(DATA_URL);

        if (response.data) formatDates(response.data);

        return response.data || [];
    } catch (error) {
        handleError(error);
    }
};

/**
 * Loop through data and format all dates
 * @param {Array} data
 */
const formatDates = function(data) {
    if (data && data.length) {
        return data.map(row => {
            for (let key in row) {
                if (FIELDS[key].isDate) row[key] = formatDate(row[key]);
            }
        });
    } else return data;
};

/**
 * Formats date as mm/dd/yyyy
 * Dates are stored in UTC midnight so we're just using substring
 * to get the exact values without time zone offset
 * @param {String} value - date string
 */
const formatDate = function(value) {
    if (!value) return null;
    else {
        let date = value.substring(0, 10).split("-");
        return date[0] + "/" + date[1] + "/" + date[2];
    }
};

export { getData };
